import { render, staticRenderFns } from "./reading.vue?vue&type=template&id=72d00ae8&scoped=true&"
import script from "./reading.vue?vue&type=script&lang=js&"
export * from "./reading.vue?vue&type=script&lang=js&"
import style0 from "./reading.vue?vue&type=style&index=0&id=72d00ae8&lang=less&scoped=true&"
import style1 from "./reading.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d00ae8",
  null
  
)

export default component.exports